const anchorsA = [
	"None (0%)", "Minimal (<10%)", "Very few (~25%)", "About half (~50%)", "Many (~75%)", "Most (>90%)", "All assigned (100%)",
];
const anchorsB = [
	"Refused or did none of the assigned exposures",
	"Attempted without intent or effort to refrain from compulsions",
	"Intended to refrain, with obvious reluctance",
	"Made a good effort but gave in to compulsions during or after exposure",
	"Completed as assigned with minimal compulsions or safety aids",
	"Performed as assigned without compulsions or safety aids",
	"Performed as assigned, facilitated or increased exposure, and extended practice into daily life",
];
const anchorsC = [
	"None (0%)", "Minimal (<10%)", "Sporadically (~25%)", "About half (~50%)", "Many (~75%)", "Most (>90%)",
	"Most (>90%) with re-exposure after slips, 100% response prevention, or no urges because symptoms are minimal",
];
const rating = (id, title, anchors, guidance, nonratingTitle) => ({
	id, type: "SCALE", title, min: 1, max: 7, isCompletionRequired: true, guidance,
	anchors: anchors.map((text, index) => ({value: index + 1, title: text})),
	nonratingOptions: [{id: `${id}-not-assigned`, title: nonratingTitle}],
});

export function createPatientExRpAdherenceScaleConfig() {
	return {
		title: "Patient EX/RP Adherence Scale (PEAS)",
		instructions: "At the beginning of the exposure session, review assigned homework, logs, and the client's account. Enter clinician ratings for the period since the last visit.",
		allowEmptyFields: true, validateFormAnswers: true, ratingScaleMax: 7,
		anchoredMean: {
			min: 1, ratingFieldIds: ["exposureQuantity", "exposureQuality", "responsePrevention"],
			sectionTitle: "Clinician adherence ratings", scoreLabel: "Session adherence mean", incompleteLabel: "Incomplete; no session mean",
			historyLabel: "Session trend", treatmentMeanLabel: "Treatment mean", evidenceLabel: "Homework evidence and client report", noteLabel: "Rating notes",
			assignedCountLabel: "Assigned exposure episodes", attemptedCountLabel: "Attempted exposure episodes",
			adaptedLabel: "Adapted practitioner template",
		},
		fields: [
			{id: "sessionDate", type: "DATE", title: "Session date"},
			{id: "homeworkStart", type: "DATE", title: "Homework period start"},
			{id: "homeworkEnd", type: "DATE", title: "Homework period end"},
			{id: "homeworkContext", type: "MULTILINE", title: "Assigned homework"},
			{id: "evidence", type: "MULTILINE", title: "Homework evidence and client report"},
			{id: "assignedCount", type: "TEXT", title: "Assigned exposure episodes"},
			{id: "attemptedCount", type: "TEXT", title: "Attempted exposure episodes"},
			rating("exposureQuantity", "Exposures: What % of exposures assigned did the patient attempt since the last visit?", anchorsA,
				"Count each assigned episode. Any genuine effort counts; a substitute counts only when comparable in difficulty and spirit. Cap attempts at the number assigned. One of two is about 50% (4); one of four is about 25% (3).", "Exposures were not assigned (99)"),
			rating("exposureQuality", "Exposures: How well did the patient do the assigned exposures that were attempted?", anchorsB,
				"Judge the average quality of attempted exposures and directly related compulsions or safety aids. Do not lower this rating for exposures not attempted. If none were attempted, rate 1. For extra attempts, assess the best assigned number.", "Exposures were not assigned (99)"),
			rating("responsePrevention", "Response prevention: What % of urges to ritualize did the patient successfully resist since the last visit?\nIf full response prevention is not yet in effect, rate compliance with the therapist's instructions.", anchorsC,
				"Include urges throughout the period, not only during exposures. Consider self-monitoring when available, but do not lower this rating because a log is missing. Use clinical judgment for discrepancies, spoiling, and avoidance. With no urges and no compulsions, the original instructions support 7; the original rating sheet also allows 99 for minimal symptoms. Record the reason for your choice.", "Response prevention not assigned, or no urges because symptoms are minimal (99)"),
			{id: "ratingNotes", type: "MULTILINE", title: "Rating notes"},
		],
	};
}

export function createPatientExRpAdherenceScaleDemoPayload() {
	return {answers: {
		sessionDate: "2026-10-29", homeworkStart: "2026-10-22", homeworkEnd: "2026-10-28",
		homeworkContext: "Touch the shared office door handle twice daily and leave without washing for 20 minutes.",
		evidence: "The exposure log records four completed attempts. The client described one ritual urge after returning home.",
		assignedCount: "14", attemptedCount: "4", ratingNotes: "Discuss the gap between planned and completed practice.",
	}};
}

export function createPatientExRpAdherenceScaleDemoPriorResults() {
	return [
		{toolType: "patientExRpAdherenceScalePeas", id: "prior-1", enginePayload: {answers: {sessionDate: "2026-10-15", homeworkStart: "2026-10-08", homeworkEnd: "2026-10-14", exposureQuantity: 3, exposureQuality: 4, responsePrevention: 4}}},
		{toolType: "patientExRpAdherenceScalePeas", id: "prior-2", enginePayload: {answers: {sessionDate: "2026-10-22", homeworkStart: "2026-10-15", homeworkEnd: "2026-10-21", exposureQuantity: 4, exposureQuality: 5, responsePrevention: 5}}},
	];
}
